import type { IPaymentTerm } from '@/interfaces'

export class PaymentTerm implements IPaymentTerm {
	groupNum: number
	paymentGroup: string
	defaultOption: string
	constructor({ groupNum, paymentGroup, defaultOption }: IPaymentTerm) {
		this.groupNum = groupNum
		this.paymentGroup = paymentGroup
		this.defaultOption = defaultOption
	}
}
